import * as React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import type { BooleanDataType, UserDefinedType } from '@glueapp/graph-types';

interface BooleanValueEditorProps {
    type: BooleanDataType;
    value: boolean;
    userDefinedType?: UserDefinedType;
    onChange: (value: boolean, updatedType?: UserDefinedType) => void;
}

export const BooleanValueEditor: React.FC<BooleanValueEditorProps> = ({ type, value, onChange }) => {
    return (
        <div className="flex flex-col pt-1">
            <Checkbox checked={value} onCheckedChange={onChange} />
        </div>
    );
};
